/**
 * 接口配置表
 */

export default {
  // 用户
  INTERFACE_LOGIN: '/property/user/common/doLogin',
  // 登录
  INTERFACE_LOGIN_OUT: '/login/user2/doLogout',
  // 登出
  INTERFACE_GET_USER_INFO: '/login/user2/getUserLoginInfo',
  // 获取信息

  INTERFACE_UPLOAD_TENCENT: '/edu/common/tencent/doUpload',
  //上传图片到腾讯云
  INTERFACE_UPLOAD_TENCENT_BASE64: '/common/tencent/doUploadBase64',
  //上传BASE64格式到腾讯云

  INTERFACE_GET_CONFIGS: "/property/propertyManage/getConfigsByType",
  //通用config
  INTERFACE_GET_MEUN_LIST: '/edu/user/common/getMenuInfo',
  // 获取菜单

  //通讯录相关
  INTERFACE_UNIT_GET: '/rights/addressbook/getMyUnitAddressBook',
  // 获取表格数据
  INTERFACE_ADDRESSBOOK_UNIT_SEARCH: "/rights/addressbook/getTeacherListOfGroupByMeSerach",
  //本单位通讯录搜索
  INTERFACE_MAIL_LIST_MY_UNIT: '/rights/getMyUnitAddressBook',
  //本单位通讯录
  INTERFACE_SELECT_LIST_TEACHER_INFO: '/rights/addressbook/getSelectTeacherListOfGroup',
  //获取部门下的教职工列表（按预定的排序顺序输出）
  INTERFACE_USER_GROUP_CHILD: '/rights/addressbook/getSelfSubList',
  // 获取组列表
  INTERFACE_GET_STUDENT_LIST_IDLABLE: '/rights/addressbook/getAllStudentListByTypeIdResultIdLable',
  //获取班级所属学生信息
  INTERFACE_GET_ALL_USER_GET: '/rights/addressbook/getGroupUserOrderList',
  // 获取
  INTERFACE_USER_GROUP_LIST: '/rights/addressbook/getSelfGroupData',
  // 获取列表
  INTERFACE_MAIL_LIST_STUDENT: '/rights/addressbook/getStudentAddressBook',
  //学生通讯录
  INTERFACE_USER_GROUP_ADD: '/rights/addressbook/insertOneSelfGroup',
  // 添加
  INTERFACE_USER_SCHOOL: '/edu/user/getSchoolHierarchy',
  // 获取教育局学校
  INTERFACE_GET_ROLE_LIST: "/rights/role/getRoleList",
  //获取所有角色
  INTERFACE_GET_STUDENT_LIST_WITH_LABEL: '/rights/addressbook/getAllStudentListByTypeIdWithLabel',
  //获取班级所属学生信息--学籍异动
  INTERFACE_MAIL_LIST_STUDENT_BY_ROLE: '/rights/addressbook/getStudentAddressBookByRole',
  //学生通讯录
  INTERFACE_MAIL_LIST_MY_AREA: '/rights/addressbook/getInteriorAddressBook',
  //本区通讯录
  INTERFACE_ADDRESSBOOK_INTERNAL_SEARCH: "/rights/addressbook/getTeacherListOfGroupByMeSerach",
  //内部通讯录搜索
  INTERFACE_GET_ALL_SCHOOL: '/rights/addressbook/getDistrictSchoolList',
  // 获取区教育局下所有学校列表
  INTERFACE_DISTRICT_FRAME_LIST_GET: "/rights/addressbook/getInteriorAddressBookAll",
  //获取区组织架构

  //快速登录
  INTERFACE_LOGIN_BY_TIKET: '/property/user/common/doLoginByTicket',
  //快速登录

  //首页数据统计
  INTERFACE_GET_APPROVE_STATIC: '/approveSupport/getApproveNum',
  //资产分类
  INTERFACE_SORT_TABLELIST: '/property/propertyManage/setting/getPropertyClassificationList',
  //获取表格列表
  INTERFACE_SORT_DETAILS: '/property/propertyManage/publicdetail/getresourcedetail',
  //获取详情
  INTERFACE_SORT_ADDEDIT: '/property/propertyManage/setting/editClassification',
  //新增或编辑一条资产分类
  INTERFACE_SORT_DELDATA: '/property/propertyManage/setting/deleteClassification',
  //删除一条资产分类
  INTERFACE_SORT_LIB_LIST: '/property/propertyManage/getPropertyCategoryList',
  //获取分类库列表接口
  INTERFACE_SORT_REMOVE: '/property/propertyManage/delPropertyCategory',
  //移除分类接口
  INTERFACE_SORT_INSERT: '/property/propertyManage/insertPropertyCategory',
  //插入分类（第二版）接口
  INTERFACE_DEF_ASSETS_IMPORT: '/property/propertyManage/importDefaultPropertys',
  //默认资产 导入
  INTERFACE_DEF_ASSETS_LIST: '/property/propertyManage/getDefaultPositionPropertys',
  //默认资产 列表
  INTERFACE_DEF_ASSETS_DEL: '/property/propertyManage/delDefaultPropertyById',
  //默认资产 删除
  INTERFACE_DEF_ASSETS_EDIT: '/property/propertyManage/updateDefaultPropertyById',
  //默认资产 编辑

  //资产位置管理
  INTERFACE_POSITION_TABLELIST: '/property/propertyManage/setting/getPropertyPositionList',
  //获取表格列表
  INTERFACE_POSITION_DETAILS: '/property/propertyManage/publicdetail/getresourcedetail',
  //获取详情
  INTERFACE_POSITION_ADDEDIT: '/property/propertyManage/setting/editPosition',
  //新增或编辑一条资产分类
  INTERFACE_POSITION_DELDATA: '/property/propertyManage/setting/deletePosition',
  //删除一条资产分类
  INTERFACE_POSITION_GET_DETAIL: '/property/propertyManage/setting/getPropertyPositionById',
  //根据id获取场地详情接口
  INTERFACE_POSITION_ADD_POS_TYPE: '/property/propertyManage/insertPositionCategory',
  //新增场地分类接口
  INTERFACE_POSITION_GET_POS_TYPE: '/property/propertyManage/getPropertyCategorysByType',
  //根据场地类型获取本单位场地分类接口
  INTERFACE_POSITION_SET_MANAGE: '/property/propertyManage/setPropertyManagersByPositionId',
  //指定资产管理员接口
  INTERFACE_POSITION_GET_CAT_PEOPERTYS: '/property/propertyManage/getPeopertysByPositionCategoryId',
  //根据场地分类id获取默认资产接口
  INTERFACE_POSITION_GET_PEOPERTYS_BY_ID: '/property/propertyManage/getPropertyListByPositionId',
  //获取场地资产列表接口
  INTERFACE_POSITION_POST_PROPERTY_EDIT: '/property/propertyManage/updatePropertyById',
  //编辑资产(只有资产名称、数量、资产管理员)接口
  INTERFACE_POSITION_POST_PROPERTY_ADD: '/property/propertyManage/insertPositionPropertys',
  //添加场地资产接口
  INTERFACE_POSITION_POST_BUILD_ADD: '/property/propertyManage/insertPropertyPositionUnit',
  //添加建筑物
  INTERFACE_POSITION_GET_BUILD_LIST: '/property/propertyManage/getPropertyPositionUnitList',
  //建筑物列表
  INTERFACE_POSITION_BATCH_EDIT_LIST: '/property/propertyManage/setting/batchEditPosition',
  //导入资产场地

  INTERFACE_POSITION_GET_BUILD_FLOOR: "/property/propertyManage/getPropertyPositionUnitList",
  // 获取建筑物层数

  INTERFACE_POSITION_SITE_TYPE_SORT_LIST: '/property/propertyManage/setting/getPropertyPositionCagetory',
  // 获取场地分类

  // 资产管理
  INTERFACE_GET_PROPERTY_LIST: '/property/propertyManage/getPropertyList',
  //获取资产管理列表
  INTERFACE_GET_PROPERTY_LIST_TWO: '/property/propertyManage/getPropertyListTwo',
  //获取资产管理列表(43001闲置，43002使用中)
  INTERFACE_IMPORT_ASSETS: '/property/propertyManage/importProperty',
  //导入设备
  INTERFACE_GET_ERR_LIST: '/property/propertyManage/getPropertyReportErrorByUid',
  //获取上次导入错误信息
  INTERFACE_GET_PROPERTY_POSITION_LIST: '/property/propertyManage/setting/getPropertyPositionList',
  //资产位置列表
  INTERFACE_GET_PROPERTY_CLASSIFICATION_LIST: '/property/propertyManage/setting/getPropertyClassificationList',
  //资产分类列表
  INTERFACE_GET_PROPERTY_MANAGERS_LIST: '/property/propertyManage/getAssetsManagersByUnitId',
  //资产管理员列表
  INTERFACE_GET_GROUP_INFO_BY_USERID: '/property/propertyManage/getGroupInfosByUserId',
  //根据user_id获取用户当前单位所属部门接口
  INTERFACE_ADD_PROPERTY: '/property/propertyManage/insertOneProperty',
  //新增一条资产
  INTERFACE_GET_EDIT_INFO: '/property/propertyManage/getPropertyById',
  //获取一条资产信息
  INTERFACE_EDIT_PROPERTY: '/property/propertyManage/updateOneProperty',
  //修改一条资产
  INTERFACE_DEL_PROPERTY: '/property/propertyManage/delPropertyById',
  //删除一条资产
  INTERFACE_BATCH_DEL_PROPERTY: '/property/propertyManage/batchDelPropertyByIds',
  //批量删除资产

  //资产维修
  INTERFACE_GET_REPAIR_RECORD_LIST: '/property/repairRecord/listRepairRecord',
  //维修单管理列表
  INTERFACE_GET_REPAIR_SETTLEMENT_LIST: '/property/repairRecord/listRepairRecordSettlement',
  //维修结算管理列表
  INTERFACE_ADD_REPAIR_RECORD: '/property/repairRecord/insertOneRepairRecord',
  //插入一条维修记录接口
  INTERFACE_GET_REPAIR_RECORD_DETAIL: '/property/repairRecord/getRepairRecordById',
  //根据id获取维修单详情接口
  INTERFACE_REPAIR_RECORD_DISPATCH: '/property/repairRecord/dispatch',
  //派单操作接口
  INTERFACE_REPAIR_RECORD_AUDIT: '/property/repairRecord/auditRepair',
  //审批操作接口

  //维修机构
  INTERFACE_GET_REPAIR_UNIT: '/property/repairRecord/getAllRepairUnits',
  //获取所有维修单位接口

  //资产统计
  INTERFACE_GET_STAT_OVERVIEW: '/property/propertyStatistics/propertyOverview',
  //资产统计-资产概览
  INTERFACE_GET_STAT_STATUS: '/property/propertyStatistics/propertyStatus',
  //资产统计/资产状态统计
  INTERFACE_GET_STAT_TYPE: '/property/propertyStatistics/propertyPosition',
  //资产统计/资产类型统计
  INTERFACE_GET_STAT_POSITION: '/property/propertyStatistics/propertyPosition',
  //资产统计/资产位置统计
  INTERFACE_GET_STAT_NUM_RANK: '/property/propertyStatistics/propertyNumRank',
  //资产统计/数量
  INTERFACE_GET_STAT_REPAIR_ORDER: '/property/propertyStatistics/propertyRepair/repairOrder',
  //维修明细统计/维修单数据
  INTERFACE_GET_STAT_REPAIR_SETTLE: '/property/propertyStatistics/propertyRepair/repairSettle',
  //维修明细统计/维修结算数据
  INTERFACE_GET_STAT_RES_GROUP: '/property/propertyStatistics/staff/groupStatistics',
  //教职工资产统计/资产按部门统计
  INTERFACE_GET_STAT_RES_PERSON_RANK: '/property/propertyStatistics/staff/propertyRank',
  //教职工资产统计/资产按人员统计

  INTERFACE_GET_STAT_RES_NUM_TYPE: '/property/propertyStatistics/getPropertyStatByClassified',
  //资产分类统计 (层级结构)
  INTERFACE_GET_STAT_RES_NUM_GROUP: '/property/propertyStatistics/getPropertyStatByGroup',
  //资产按部门统计 (层级结构)
  INTERFACE_GET_STAT_RES_NUM_POSITION: '/property/propertyStatistics/getPropertyStatByPosition',
  //资产按位置统计 (层级结构)
  INTERFACE_GET_STAT_RES_NUM_BIDDER: '/property/propertyStatistics/getPropertyOverview',
  //维保

  //资产套装
  INTERFACE_GET_MULITIMEDIA_LIST: '/property/propertyManage/getPropertyMediaList',
  //获取多媒体资产列表接口
  INTERFACE_GET_MULITIMEDIA_DEF_PEOPERTY: '/property/propertyManage/getDefaultPropertys',
  //根据多媒体系统id获取默认资产接口
  INTERFACE_GET_MULITIMEDIA_DETAIL: '/property/propertyManage/getPropertyMediaById',
  //据多媒体系统资产id获取详情接口
  INTERFACE_GET_MULITIMEDIA_ASSETS_LIST: '/property/propertyManage/getPropertysByMediaId',
  //据多媒体系统资产id获取详情接口
  INTERFACE_POST_MULITIMEDIA_ASSETS_REMOVE: '/property/propertyManage/removePropertyByPropertyId',
  //移除资产与多媒体系统资产关系接口
  INTERFACE_POST_MULITIMEDIA_ASSETS_ADD: '/property/propertyManage/insertMediaPropertys',
  //添加多媒体系统资产接口
  INTERFACE_POST_MULITIMEDIA_ADD: '/property/propertyManage/insertPropertyMedia',
  //新增多媒体资产接口
  INTERFACE_POST_MULITIMEDIA_EDIT: '/property/propertyManage/updatePropertyMediaById',
  //编辑多媒体资产接口
  INTERFACE_GET_ASSETS_LIST_BY_POSITION: '/property/propertyManage/getPropertyMediaListByPositionId',
  //根据场地id获取多媒体系统资产接口
  INTERFACE_POST_MULITIMEDIA_DEL: '/property/propertyManage/delPropertyMediaById',
  //根据id删除多媒体系统资产接口

  // 获取待办事项
  INTERFACE_GET_INDEX_TODO_LIST: '/property/todo/getTodoList' // 获取首页待办事项
};